"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _useFullscreen2 = require("../hooks/useFullscreen");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FullScreenItem = function FullScreenItem() {
  var _useFullscreen = (0, _useFullscreen2.useFullscreen)(),
    allowed = _useFullscreen.allowed,
    isFullscreen = _useFullscreen.isFullscreen,
    toggleFullscreen = _useFullscreen.toggleFullscreen;
  if (!allowed) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
    onClick: function onClick() {
      toggleFullscreen();
    },
    "data-testid": "full_screen_btn",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExpandIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
      variant: "sm",
      css: {
        ml: "$4"
      },
      children: [isFullscreen ? "Exit " : "Go ", "Fullscreen"]
    })]
  });
};
exports.FullScreenItem = FullScreenItem;